import { Component, _decorator } from 'cc';
import Game from '../Game';
import globalInstance from './GlobalInstance';

const { ccclass, executionOrder } = _decorator;

@ccclass('GameDependency')
@executionOrder(-1)
export default class GameDependency extends Component {
    private _game: Game = null;

    public get game(): Game {
        if (!this._game) {
            this._game = globalInstance.game;
        }
        return this._game;
    }

    public set game(value: Game) {
        this._game = value;
    }
}
